<svg width="32" height="32">
    <path fill="#FFF" d="M26 28H6V4h14l6 6"/>
    <path fill="#AFBCC6" d="M20.5 2H7.01C6.45 2 6 2.44 6 2.99V7h2V4h12v4.99c0 .56.45 1.01 1.01 1.01H26v18H8v-3H6v3.99c0 .56.45 1.01 1.01 1.01h20c.55 0 .99-.45.99-1.01V9.5L20.5 2z"/>

    <g *ngIf="isDjvu()">
        <path fill="#662D91" d="M3 8h14c.552 0 1 .448 1 1v14c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1V9c0-.552.448-1 1-1z"/>
        <path fill="#FFAB40" d="M7 16.055l8.942-3.134 3.135 8.946L10.133 25z"/>
        <path fill="#FFF" d="M13.968 13.62L8.356 7.994l-1.557.01 6.015 6.016 1.152-.4zM2 12.54v1.56l6.64 6.637-.84-2.394L2 12.54zM5.24 8H3.682l6.964 6.964c.925.925.683 1.423.284 1.822-.485.486-.952.622-1.775-.2L2 9.43v1.555l6.378 6.378c1.537 1.537 2.747.786 3.332.2s1.31-1.785-.284-3.378L5.24 8z"/>
    </g>

    <g *ngIf="isPicture()">
        <path fill="#93278F" d="M17 24H3c-.552 0-1-.448-1-1V9c0-.552.448-1 1-1h14c.552 0 1 .448 1 1v14c0 .552-.448 1-1 1z"/>
        <circle cx="7.01" cy="11.009" r="1.231" fill="#FFF"/>
        <path fill="#FFF" d="M15.87 19.218l-3.806-6.548c-.11-.222-.395-.227-.52-.015l-2.058 3.602-1.456-2.14c-.087-.156-.435-.156-.525 0 0 0-3.09 4.76-3.368 5.16-.246.342-.146.703.183.703h11.292c.376 0 .513-.315.257-.762z"/>
    </g>

    <g *ngIf="isPdf()">
        <path fill="#C60C30" d="M17 24H3c-.552 0-1-.448-1-1V9c0-.552.448-1 1-1h14c.552 0 1 .448 1 1v14c0 .552-.448 1-1 1z"/>
        <path fill="#FFF" d="M6.24 13H4v6h1v-2h1.25c1.005 0 1.38-.75 1.38-1.502v-.996c0-.77-.375-1.502-1.39-1.502zm-.51 3H5v-2h.73c.77 0 1.02.243 1.02 1 0 .74-.25 1-1.02 1zm4.772-3H8.24v6h2.262c1.24 0 1.678-.733 1.678-1.502v-2.996c0-.76-.44-1.502-1.678-1.502zm.678 4.224c0 .463-.247.776-.678.776H9.24v-4h1.254c.44 0 .686.29.686.745v2.48zM13 13h3.2v1H14v2h1.4v1H14v2h-1"/>
    </g>

    <g *ngIf="isUnsupported()">
        <polygon id="Shape" fill="#FFFFFF" points="20 26 0 26 0 2 14 2 20 8"></polygon>
        <path d="M2,5 L2,2 L14,2 L14,7 C14,7.6 14.5,8 15,8 L20,8 L20,26 L2,26 M0,23 L0,27 C0,27.6 0.4,28 1,28 L21,28 C21.5,28 22,27.5 22,27 L22,7.5 L14.5,0 L1,0 C0.4,0 0,0.4 0,1 L0,5" id="Shape" fill="#AFBCC6"></path>
    </g>

</svg>